import React, { useState } from 'react'
import {useSelector} from "react-redux";
import {Alert, Card, CardBody, CardTitle, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";



// components
import NotifyForm from "./_notifyForm";
import Loading from "../../../components/loader/Loading";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import { TT_CLOSE } from "../../../components/i18n/toolTips";

// hooks
import useAllotmentNotificationLabels from "../../../hooks/useAllotmentNotificationLabels";

// utils
import {getStateByPath} from "../../../redux/selectors";


const NotifyAllotment = ({activity, allotment, onClose, path}) => {
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading:componentStateLoading} = componentState?.data || {};
    
    

    const {
        isLoading:loadingNotificationLabel,
        message,
        labels
    } = useAllotmentNotificationLabels(activity, allotment)


    const [activeTab, setActiveTab] = useState(0)


    const onChangeTab = (tab) => setActiveTab(tab)


    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="fa fa-bell-o" aria-hidden="true"/> Notificar Allotment
            <div className={'top-right'}>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={() => onClose()}
                />
            </div>
        </CardTitle>
        <CardBody className={'card-body-modal'}>

            {
                loadingNotificationLabel  && <Loading isLoading={true} title={ 'Buscando la notificación' }/>
            }

            {
                componentStateLoading  && <Loading isLoading={true} title={''}/>
            }


            {
                message && <Alert color={'warning'}>
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"/>
                    &nbsp; {message}
                </Alert>
            }

            {
                labels.length > 0 &&  <div>
                    <Nav tabs>
                        {
                            labels.map((label, index) => <NavItem key={index}>
                                <NavLink
                                    className={activeTab === index ? 'active' : ''}
                                    onClick={() => onChangeTab(index)}
                                >
                                    {label.lang?.name}
                                </NavLink>

                            </NavItem>)
                        }
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        {
                            labels.map( (label, index) => <TabPane key={`${index}`} tabId={index} className={'p-4'}>
                                <NotifyForm {...label} path={path} activity={activity}/>
                            </TabPane>)
                        }
                    </TabContent>
                </div>
            }
        </CardBody>
    </Card>
}

export default NotifyAllotment